export default __webpack_public_path__ + "static/media/bg.0717abbc.svg";